import type { TranslationModule } from '../types';

export const headerTranslations: TranslationModule = {
  ro: {
    exams: "Admitere",
    legislation: "Legislație",
    jurisprudence: "Jurisprudență",
    nationalJurisprudence: "Jurisprudență Națională",
    europeanJurisprudence: "Jurisprudență Europeană",
    judicialPractice: "Practică Judiciară",
    publicCases: "Cazuri pe înțelesul tău",
    publicCasesDesc: "Pentru cei fără pregătire juridică",
    courtDecisions: "Hotărâri judecătorești",
    courtDecisionsDesc: "Căutare hotărâri și decizii.",
    cedoDesc: "Curtea Europeană a Drepturilor Omului.",
    iccjDesc: "Înalta Curte de Casație și Justiție.",
    useful: "Admitere & Utile",
    calculators: "Calculatoare",
    calcTaxaTimbru: "Calculator Taxă Timbru",
    calcTaxaTimbruDesc: "Calculează taxele judiciare.",
    calcTermene: "Calculator Termene Judiciare",
    calcTermeneDesc: "Calculează termenele procedurale.",
    calcContopiri: "Calculator Contopiri Pedepse",
    calcContopiriDesc: "Calculează pedeapsa rezultantă.",
    calcPensieAlimentara: "Calculator Pensie Alimentară",
    calcPensieAlimentaraDesc: "Copii, soți și rude · plafoane și buget.",
    calcTermeneLegale: "Calculator Termene Legale",
    calcTermeneLegaleDesc: "Prescripție, decădere și situații civile.",
    calcLimite: "Calculator Limite Pedeapsă",
    calcLimiteDesc: "Determină limitele pedepsei.",
    calcPrescriptie: "Calculator Prescripție Penală",
    calcPrescriptieDesc: "Calculează termenul de prescripție.",
    calcReabilitare: "Calculator Reabilitare",
    calcReabilitareDesc: "Verifică termenul de reabilitare.",
    calcSalariu: "Calculator Salariu Net / Brut",
    calcSalariuDesc: "Calculează salariul net și brut.",
    perspectives: "Perspective",
    perspectivesDesc: "Argumente și analize juridice organizate pe materii și obiecte.",
    studyTools: "Pregătire Examene",
    mobileStudyTools: "Pregătire Admitere",
    activeLearning: "Învață codurile pe de rost",
    memorization: "Elemente de memorat",
    memorizationDesc: "Clasificări, excepții și reguli de reținut prin repetare.",
    legalSchemes: "Scheme juridice",
    legalSchemesDesc: "Înțelege și memorează regulile de drept prin scheme vizuale.",
    activeLearningDesc: "Reamintește, ascultă și repetă articolele de lege.",
    audioQuizzes: "Audio Grile",
    audioQuizzesDesc: "Rezolvă grile și ascultă explicațiile.",
    audioLegislation: "Audio Legislație",
    audioLegislationDesc: "Legislația la zi în format audio.",
    pdfConverter: "Convertor PDF to Word",
    pdfConverterDesc: "Transformă documentele rapid.",
    docAnonymizer: "Anonimizare documente",
    docAnonymizerDesc: "Elimină automat datele personale înainte de partajare.",
    efficientStudy: "Studiu eficient",
    discoverAudio: "Descoperă funcționalitățile audio",
    discoverAudioDesc: "Ascultă legislația sau rezolvă grile oriunde, oricând, într-un format interactiv și captivant.",
    aiJuridic: "AI Juridic",
    studyWithAI: "Învață pentru examene cu LegeaAplicată",
    studyWithAIDesc: "Tehnologia te sprijină în asimilarea informației folosind cele mai noi modele de limbaj și inteligență.",
    legalActivity: "Activitate Legală",
    justPortal: "Portal Just",
    justPortalDesc: "Caută jurisprudență.",
    extrasCF: "Extras CF",
    extrasCFDesc: "Descarcă online.",
    createCompany: "Înființează Firmă",
    createCompanyDesc: "Wizard rapid.",
    addCase: "Adaugă speță",
    addCaseDesc: "Bază de date.",
    otherTools: "Alte Instrumente",
    legalNews: "Știri Juridice",
    legalNewsDesc: "Fii la curent.",
    legalDict: "Dicționar Juridic",
    legalDictDesc: "Definiții juridice online.",
    docAnalysis: "Analiză Document",
    docAnalysisDesc: "Analizează rapid documente juridice.",
    docEditor: "Editor DOCX",
    docEditorDesc: "Editor DOCX online cu citări, analiză și anonimizare.",
    crmPro: "CRM Profesioniști",
    crmProDesc: "Gestionează clienți, dosare și activitatea profesională.",
    practicaNeunitara: "Practică neunitară",
    practicaNeunitaraDesc: "Probleme de drept și soluții INM.",
    jurnalPracticaJudiciara: "Jurnal de practică judiciară",
    jurnalPracticaJudiciaraDesc: "Analize și bune practici ale instanțelor.",
    competence: "Circumscripții",
    competenceDesc: "Instanțe competente.",
    contacts: "Agendă Contacte",
    contactsDesc: "Instituții și departamente.",
    taxCalculator: "Calculator taxe",
    taxCalculatorDesc: "Taxe judiciare.",
    roiReport: "Raport ROI",
    roiReportDesc: "Calcul eficiență AI.",
    latestNews: "Ultimele Știri",
    latestNewsTitle: "Află ce se întâmplă în lumea juridică",
    latestNewsDesc: "Articole publicate de echipa LegeaAplicată pentru a te ține mereu cu un pas înainte în carieră.",
    futureInvestment: "Investiție în viitor",
    roiReportTitle: "Raport ROI Profesional",
    roiReportSub: "Crește-ți veniturile cu A.I.",
    roiReportDescText: "Află cât timp și bani economisești implementând inteligența artificială în biroul tău.",
    followedCases: "Dosare urmărite",
    guide: "Ghidul funcțiilor",
    guideDesc: "Matrice & ghid interactiv pentru toate funcțiile.",
    legislativeChanges: "Modificări Legislative la Zi",
    legislativeChangesDesc: "Monitorul Oficial · 40 de acte & alerte email.",
    legislativeChangesMobile: "Modificări Legislative la Zi (40 Acte)",
    financialMarkets: "Piețe Financiare",
    financialMarketsDesc: "Curs BNR, convertor, indicatori BCE & Eurostat, burse.",
    themeLight: "Activează tema luminoasă",
    themeDark: "Activează tema întunecată",
    langSelectorTitle: "Limbă / Language"
  },
  en: {
    exams: "Exams",
    legislation: "Legislation",
    jurisprudence: "Jurisprudence",
    nationalJurisprudence: "National Case Law",
    europeanJurisprudence: "European Case Law",
    judicialPractice: "Judicial Practice",
    publicCases: "Cases in Plain Language",
    publicCasesDesc: "For those without legal training",
    courtDecisions: "Court Decisions",
    courtDecisionsDesc: "Search court decisions and rulings.",
    cedoDesc: "European Court of Human Rights.",
    iccjDesc: "High Court of Cassation and Justice.",
    useful: "Useful",
    calculators: "Calculators",
    calcTaxaTimbru: "Court Fee Calculator",
    calcTaxaTimbruDesc: "Calculate judicial court taxes.",
    calcTermene: "Procedural Deadlines Calculator",
    calcTermeneDesc: "Calculate procedural time limits.",
    calcContopiri: "Sentence Merger Calculator",
    calcContopiriDesc: "Calculate resulting penalty.",
    calcPensieAlimentara: "Child Maintenance Calculator",
    calcPensieAlimentaraDesc: "Children, spouses and relatives · caps and budget.",
    calcTermeneLegale: "Legal Deadlines Calculator",
    calcTermeneLegaleDesc: "Prescription, forfeiture and civil deadlines.",
    calcLimite: "Penalty Limits Calculator",
    calcLimiteDesc: "Determine sentencing boundaries.",
    calcPrescriptie: "Criminal Prescription Calculator",
    calcPrescriptieDesc: "Calculate limitation period.",
    calcReabilitare: "Rehabilitation Calculator",
    calcReabilitareDesc: "Check rehabilitation period.",
    calcSalariu: "Net / Gross Salary Calculator",
    calcSalariuDesc: "Calculate net and gross income.",
    perspectives: "Perspectives",
    perspectivesDesc: "Legal arguments and analyses organized by legal field and subject.",
    studyTools: "Study Tools",
    mobileStudyTools: "Study Tools",
    activeLearning: "Learn the codes by heart",
    memorization: "Legal memory essentials",
    memorizationDesc: "Learn classifications, exceptions and rules through repetition.",
    legalSchemes: "Legal Flowcharts",
    legalSchemesDesc: "Understand and memorize legal rules through visual flowcharts.",
    activeLearningDesc: "Recall, listen to and review legal articles.",
    audioQuizzes: "Audio Quizzes",
    audioQuizzesDesc: "Solve quiz questions and listen to legal explanations.",
    audioLegislation: "Audio Legislation",
    audioLegislationDesc: "Up-to-date legislation in audio format.",
    pdfConverter: "PDF to Word Converter",
    pdfConverterDesc: "Convert document files quickly.",
    docAnonymizer: "Document anonymization",
    docAnonymizerDesc: "Automatically mask personal data before sharing.",
    efficientStudy: "Efficient Study",
    discoverAudio: "Discover Audio Features",
    discoverAudioDesc: "Listen to legislation or solve quiz questions anywhere, anytime, in an interactive and engaging format.",
    aiJuridic: "Legal AI",
    studyWithAI: "Learn for Exams with LegeaAplicată",
    studyWithAIDesc: "Technology supports you in acquiring information using state-of-the-art language models.",
    legalActivity: "Legal Practice",
    justPortal: "Just Portal",
    justPortalDesc: "Search judicial jurisprudence.",
    extrasCF: "Land Registry Extract",
    extrasCFDesc: "Download online.",
    createCompany: "Incorporate Company",
    createCompanyDesc: "Fast setup wizard.",
    addCase: "Add Case",
    addCaseDesc: "Database entry.",
    otherTools: "Other Instruments",
    legalNews: "Legal News",
    legalNewsDesc: "Stay informed.",
    legalDict: "Legal Dictionary",
    legalDictDesc: "Online legal definitions.",
    docAnalysis: "Document Analysis",
    docAnalysisDesc: "Quickly analyze legal documents.",
    docEditor: "DOCX Editor",
    docEditorDesc: "Online DOCX editor with citations, analysis and anonymization.",
    crmPro: "Professional CRM",
    crmProDesc: "Manage clients, cases and legal practice.",
    practicaNeunitara: "Divergent case law",
    practicaNeunitaraDesc: "Legal issues and INM solutions.",
    jurnalPracticaJudiciara: "Judicial practice journal",
    jurnalPracticaJudiciaraDesc: "Court analyses and good practices.",
    competence: "Jurisdictions",
    competenceDesc: "Competent courts search.",
    contacts: "Contact Directory",
    contactsDesc: "Public institutions and departments.",
    taxCalculator: "Court Fee Calculator",
    taxCalculatorDesc: "Calculate legal court taxes.",
    roiReport: "ROI Report",
    roiReportDesc: "Calculate AI efficiency.",
    latestNews: "Latest News",
    latestNewsTitle: "Latest Happenings in the Legal World",
    latestNewsDesc: "Articles published by the LegeaAplicată team to keep you one step ahead in your legal career.",
    futureInvestment: "Investment in the Future",
    roiReportTitle: "Professional ROI Report",
    roiReportSub: "Increase Your Revenue with AI",
    roiReportDescText: "Find out how much time and money you save by implementing artificial intelligence in your practice.",
    followedCases: "Followed cases",
    guide: "Features Guide",
    guideDesc: "Interactive matrix and navigation across all platform tools.",
    legislativeChanges: "Daily Legislative Changes",
    legislativeChangesDesc: "Official Gazette · 40 fundamental acts & email alerts.",
    legislativeChangesMobile: "Daily Legislative Changes (40 Acts)",
    financialMarkets: "Financial Markets",
    financialMarketsDesc: "NBR FX rates, converter, ECB & Eurostat indicators, stock exchanges.",
    themeLight: "Switch to light theme",
    themeDark: "Switch to dark theme",
    langSelectorTitle: "Limbă / Language"
  },
  fr: {
    exams: "Examens",
    legislation: "Législation",
    jurisprudence: "Jurisprudence",
    nationalJurisprudence: "Jurisprudence Nationale",
    europeanJurisprudence: "Jurisprudence Européenne",
    judicialPractice: "Pratique Judiciaire",
    publicCases: "Cas expliqués simplement",
    publicCasesDesc: "Pour les personnes sans formation juridique",
    courtDecisions: "Décisions de Justice",
    courtDecisionsDesc: "Recherche de décisions et arrêts.",
    cedoDesc: "Cour Européenne des Droits de l'Homme.",
    iccjDesc: "Haute Cour de Cassation et de Justice.",
    useful: "Utiles",
    calculators: "Calculateurs",
    calcTaxaTimbru: "Calculateur de Taxe de Timbre",
    calcTaxaTimbruDesc: "Calculez les frais judiciaires.",
    calcTermene: "Calculateur de Délais Judiciaires",
    calcTermeneDesc: "Calculez les délais de procédure.",
    calcContopiri: "Calculateur de Confusion de Peines",
    calcContopiriDesc: "Calculez la peine résultante.",
    calcPensieAlimentara: "Calculateur de Pension Alimentaire",
    calcPensieAlimentaraDesc: "Enfants, conjoints et proches · plafonds et budget.",
    calcTermeneLegale: "Calculateur de Délais Légaux",
    calcTermeneLegaleDesc: "Prescription, forclusion et délais civils.",
    calcLimite: "Calculateur de Limites de Peine",
    calcLimiteDesc: "Déterminez les limites de la peine.",
    calcPrescriptie: "Calculateur de Prescription Pénale",
    calcPrescriptieDesc: "Calculez le délai de prescription.",
    calcReabilitare: "Calculateur de Réhabilitation",
    calcReabilitareDesc: "Vérifiez le délai de réhabilitation.",
    calcSalariu: "Calculateur de Salaire Net / Brut",
    calcSalariuDesc: "Calculez le salaire net et brut.",
    perspectives: "Perspectives",
    perspectivesDesc: "Arguments et analyses juridiques classés par matière et par objet.",
    studyTools: "Outils d'Étude",
    mobileStudyTools: "Outils d'Étude",
    audioQuizzes: "QCM Audio",
    memorization: "Éléments à mémoriser",
    memorizationDesc: "Classifications, exceptions et règles à retenir par la répétition.",
    legalSchemes: "Schémas juridiques",
    legalSchemesDesc: "Comprendre et mémoriser les règles de droit grâce à des schémas visuels.",
    audioQuizzesDesc: "Résolvez des QCM et écoutez les explications juridiques.",
    audioLegislation: "Législation Audio",
    audioLegislationDesc: "La législation à jour au format audio.",
    pdfConverter: "Convertisseur PDF en Word",
    pdfConverterDesc: "Transformez vos documents rapidement.",
    docAnonymizer: "Anonymisation de documents",
    docAnonymizerDesc: "Masquez automatiquement les données personnelles avant le partage.",
    efficientStudy: "Étude efficace",
    discoverAudio: "Découvrez les fonctions audio",
    discoverAudioDesc: "Écoutez la législation ou résolvez des QCM n'importe où, n'importe quand, dans un format interactif et captivant.",
    aiJuridic: "IA Juridique",
    studyWithAI: "Apprenez pour vos examens avec LegeaAplicată",
    studyWithAIDesc: "La technologie vous soutient dans l'assimilation d'informations en utilisant les derniers modèles de langage.",
    legalActivity: "Pratique Juridique",
    justPortal: "Portail Just",
    justPortalDesc: "Recherchez de la jurisprudence.",
    extrasCF: "Extrait de Registre Foncier",
    extrasCFDesc: "Téléchargez en ligne.",
    createCompany: "Créer une Entreprise",
    createCompanyDesc: "Assistant de création rapide.",
    addCase: "Ajouter un dossier",
    addCaseDesc: "Entrée de base de données.",
    otherTools: "Autres Outils",
    legalNews: "Actualités Juridiques",
    legalNewsDesc: "Restez informé.",
    legalDict: "Dictionnaire Juridique",
    legalDictDesc: "Définitions juridiques en ligne.",
    docAnalysis: "Analyse de Documents",
    docAnalysisDesc: "Analysez rapidement vos documents juridiques.",
    docEditor: "Éditeur DOCX",
    docEditorDesc: "Éditeur DOCX en ligne avec citations, analyse et anonymisation.",
    crmPro: "CRM Professionnels",
    crmProDesc: "Gérez clients, dossiers et activité juridique.",
    practicaNeunitara: "Pratique judiciaire divergente",
    practicaNeunitaraDesc: "Questions de droit et solutions de l’INM.",
    jurnalPracticaJudiciara: "Revue de pratique judiciaire",
    jurnalPracticaJudiciaraDesc: "Analyses et bonnes pratiques des juridictions.",
    competence: "Compétences Territoriales",
    competenceDesc: "Recherche de tribunaux compétents.",
    contacts: "Annuaire de Contacts",
    contactsDesc: "Institutions publiques et départements.",
    taxCalculator: "Calculateur de Frais",
    taxCalculatorDesc: "Calcul des taxes judiciaires et droits de greffe.",
    roiReport: "Rapport ROI",
    roiReportDesc: "Calcul de l'efficacité de l'IA.",
    latestNews: "Dernières Nouvelles",
    latestNewsTitle: "Actualités du Monde Juridique",
    latestNewsDesc: "Articles publiés par l'équipe LegeaAplicată pour vous garder une longueur d'avance dans votre carrière.",
    futureInvestment: "Investissement d'Avenir",
    roiReportTitle: "Rapport ROI Professionnel",
    roiReportSub: "Augmentez Vos Revenus Grâce à l'IA",
    roiReportDescText: "Découvrez combien de temps et d'argent vous économisez en intégrant l'intelligence artificielle dans votre cabinet.",
    followedCases: "Dossiers suivis",
    guide: "Guide des fonctions",
    guideDesc: "Matrice et navigation interactive à travers les fonctions.",
    legislativeChanges: "Modifications Législatives au Quotidien",
    legislativeChangesDesc: "Journal Officiel · 40 actes fondamentaux & alertes e-mail.",
    legislativeChangesMobile: "Modifications Législatives au Quotidien (40 Actes)",
    financialMarkets: "Marchés Financiers",
    financialMarketsDesc: "Taux BNR, convertisseur, indicateurs BCE & Eurostat, bourses.",
    themeLight: "Activer le thème clair",
    themeDark: "Activer le thème sombre",
    langSelectorTitle: "Langue / Language"
  }
};

export default headerTranslations;
